/** @format */

import React, { FC, useState, useEffect } from 'react'
import { _$, Message, Button } from '@king-design/react'
import styled from 'styled-components'
import { TablePage } from 'src/components'
import { useAsync } from 'react-use'
import { GetListSysEvents } from 'src/api/ApiAlarmServer'
interface SelectEventTableProps {
  className?: string
  productType?: number
  defaultValues?: any[]
  required?: boolean
  onChange?: (values: any[]) => void
}

const SelectEventTable: FC<SelectEventTableProps> = ({
  className,
  productType = 999,
  required,
  onChange,
  defaultValues
}) => {
  // 事件
  const [selectedEventData, setSelectedEventData] = useState([]) // 已选事件data

  // 获取事件列表
  const { value: eventList } = useAsync(async () => {
    const result = await GetListSysEvents({
      ProductType: productType
    })
    if (result && result?.code === 'Success' && result?.data.eventList) {
      const eventList = result.data.eventList
      return eventList
    } else {
      Message.error(result?.message)
      return null
    }
  }, [productType])

  // 设置初始值
  useEffect(() => {
    if (eventList?.length && defaultValues?.length) {
      const update = eventList.filter(event => defaultValues.includes(event.name))
      setSelectedEventData(update)
    }
  }, [eventList, defaultValues])

  const selectedScheme = {
    nameDesc: {
      title: _$('事件名称'),
      width: 320
    },
    eventLevel: {
      title: _$('事件等级'),
      width: 120
    },
    eventTypeDesc: {
      title: _$('事件类型'),
      width: 320
    },
    active: {
      title: _$('操作'),
      width: 60,
      template: item => {
        const selected = selectedEventData?.find(event => event.name === item.name)
        return selected ? (
          <Button
            type="secondary"
            size="small"
            disabled={required && selectedEventData?.length === 1}
            onClick={() => {
              const update = selectedEventData.filter(event => event.name !== item.name)
              setSelectedEventData(update)
              onChange && onChange(update)
            }}
          >
            {_$('解绑')}
          </Button>
        ) : (
          <Button
            type="primary"
            size="small"
            onClick={() => {
              const update = [...selectedEventData, item]
              setSelectedEventData(update)
              onChange && onChange(update)
            }}
          >
            {_$('绑定')}
          </Button>
        )
      }
    }
  }

  return (
    <div className={className}>
      <TablePage
        tableProps={{
          className: 'marginTop',
          rowKey: ({ name }) => name,
          scheme: selectedScheme,
          data: eventList,
          checkType: 'none'
        }}
      />
    </div>
  )
}

export default styled(SelectEventTable)``
